import { queryAdminUsers } from 'store/reducers-admin/Users/query'

import { queryApplications } from './Applications/query'

export const reducersAdmin = {
  [queryAdminUsers.reducerPath]: queryAdminUsers.reducer,
  [queryApplications.reducerPath]: queryApplications.reducer,
}
export type ReducersAdmin = typeof reducersAdmin

export const middlewareAdmin = [queryApplications.middleware, queryAdminUsers.middleware]

export type MiddlewareAdmin = typeof middlewareAdmin
